import { createBrowserRouter, Navigate } from 'react-router-dom'
import React, { lazy, Suspense } from 'react'
import Header from './pages/components/Header/Header'
import HeaderMobile from './pages/components/Header/HeaderMobile/HeaderMobile'
import PreviewNavMobile from './pages/components/Content/PreviewCategories/PreviewNav/PreviewNavMobile/PreviewNavMobile'
import ToTopBtn from './pages/components/Content/ToTopBtn/ToTopBtn'
import FilterModal from './pages/components/ModalWindows/FilterModal/FilterModal'
import SectionErrorBoundary from './components/SectionErrorBoundary/SectionErrorBoundary'

const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
    Loading…
  </div>
)

const withLazy = (factory) => {
  const Comp = lazy(factory)
  return function LazyPage(props) {
    return (
      <Suspense fallback={<PageLoader />}>
        <Comp {...props} />
      </Suspense>
    )
  }
}

const withSection = (section, element) => (
  <SectionErrorBoundary section={section}>{element}</SectionErrorBoundary>
)

const CategoriesPage = withLazy(() => import('./pages/components/Content/Categories/CategoriesPage'))
const ComplitedPayCart = withLazy(() => import('./pages/components/Orders/Complited/ComplitedPayCart'))
const SearchPage = withLazy(() => import('./pages/components/Content/SearchPage/SearchPage'))
const PreviewAll = withLazy(() => import('./pages/components/Content/PreviewCategories/PreviewAll/PreviewAll'))
const OrderPage = withLazy(() => import('./pages/components/Account/Profile/MainSection/OrderPage/OrderPage'))
const ProfileMobile = withLazy(() => import('./pages/components/Account/Profile/ProfileMobile/ProfileMobile'))
const PreviewList = withLazy(() => import('./pages/components/Content/PreviewCategories/PreviewList/PreviewList'))
const ItemPage = withLazy(() => import('./pages/components/ItemPage/ItemPage'))
const ProfileHome = withLazy(() => import('./pages/components/Account/Profile/ProfileHome/ProfileHome'))
const ProfileInfo = withLazy(() => import('./pages/components/Account/Profile/ProfileInfo/ProfileInfo'))
const ProfileOrders = withLazy(() => import('./pages/components/Account/Profile/ProfileOrders/ProfileOrders'))
const ProfileLanguages = withLazy(() => import('./pages/components/Account/Profile/ProfileLanguages/ProfileLanguages'))
const DatosPage = withLazy(() => import('./pages/components/Account/Profile/ProfileMobile/DatosPage/DatosPage'))
const OrderPageMobile = withLazy(() => import('./pages/components/Account/Profile/ProfileMobile/OrderPageMobile/OrderPageMobile'))
const NewOrderPage = withLazy(() => import('./pages/components/NewOrderPage/NewOrderPage'))
const SpecializationPage = withLazy(() => import('./pages/SpecializationPage/SpecializationPage'))
const SpecializationCategoryPage = withLazy(() => import('./pages/SpecializationCategoryPage/SpecializationCategoryPage'))
const ShadowPage = withLazy(() => import('./pages/ShadowPage/ShadowPage'))
const HomePage = withLazy(() => import('./pages/HomePage/HomePage'))
const HomeTab = withLazy(() => import('./pages/HomeTab/HomeTab'))
const AllTab = withLazy(() => import('./pages/AllTab/AllTab'))
const StaticPage = withLazy(() => import('./pages/ProfilePage/StaticPage/StaticPage'))
const SalePage = withLazy(() => import('./pages/SalePage/SalePage'))
const StaticOrderFP = withLazy(() =>
  import('./pages/ProfilePage/StaticOrder/StaticOrderFP/StaticOrderFP').then((m) => ({
    default: m.StaticOrderFP,
  })),
)
const SaleNewOrderPage = withLazy(() => import('./pages/SaleNewOrderPage/SaleNewOrderPage.jsx'))
const SaleMyOrders = withLazy(() => import('./pages/SaleMyOrders/SaleMyOrders.jsx'))
const AlbaranPage = withLazy(() =>
  import('./pages/ProfilePage/StaticOrder/StaticOrderFP/AlbaranPage.jsx').then((m) => ({
    default: m.AlbaranPage,
  })),
)
const OwnerPage = withLazy(() => import('./pages/OwnerPage/OwnerPage.jsx'))
const FacturaPage = withLazy(() => import('./pages/ProfilePage/StaticOrder/StaticOrderFP/FacturaPage.jsx'))
const CatalogPage = withLazy(() => import('./pages/CatalogPage/CatalogPage.jsx'))
const OrderPageLogistic = withLazy(() => import('./pages/components/OrderPageLogistic/OrderPageLogistic'))

export const routerDeleverItems = createBrowserRouter([
  {
    path: '*',
    element: <Navigate to={'/home'} />,
  },
  {
    path: '/home',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <HomePage />
      </div>
    ),
  },
  {
    path: '/home/:tab',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <HomeTab />
      </div>
    ),
  },
  {
    path: '/home/:mod/:tab',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <AllTab />
      </div>
    ),
  },
  {
    path: '/searchPage',
    element: (
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SearchPage />
      </div>
    ),
  },
  {
    path: '/searchPage/:tradeName',
    element: (
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SearchPage />
      </div>
    ),
  },
  {
    path: '/categories',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <PreviewList />
      </div>
    ),
  },
  {
    path: '/categories/:categoryType',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <FilterModal />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <PreviewAll />
      </div>
    ),
  },
  {
    path: '/categories/:categoryType/:categoryName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <CategoriesPage />
      </div>
    ),
  },
  {
    path: '/categories/:categoryType/:categoryName/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <CategoriesPage />
      </div>
    ),
  },
  {
    path: '/specialization/:specializationName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SpecializationPage />
      </div>
    ),
  },
  {
    path: '/specialization/:specializationName/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SpecializationPage />
      </div>
    ),
  },
  {
    path: '/specialization/:specializationName/:categoryName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SpecializationCategoryPage />
      </div>
    ),
  },
  {
    path: '/specialization/:specializationName/:categoryName/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SpecializationCategoryPage />
      </div>
    ),
  },
  {
    path: '/profile/home',
    element: withSection(
      'perfil',
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ProfileHome />
        <HomePage />
      </div>,
    ),
  },
  {
    path: '/profile/info',
    element: withSection(
      'perfil',
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ProfileInfo />
        <div className='DatosPageMobile'>
          <DatosPage />
        </div>
      </div>,
    ),
  },
  {
    path: '/profile/orders',
    element: withSection(
      'historial de pedidos',
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ProfileOrders />
        <OrderPageMobile />
      </div>,
    ),
  },
  {
    path: '/profile/languages',
    element: withSection(
      'perfil',
      <div className='App__container' style={{ display: 'flex', flexDirection: 'column' }}>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ProfileLanguages />
        <ProfileMobile />
      </div>,
    ),
  },
  {
    path: '/order/:orderId',
    element: withSection(
      'pedido',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <OrderPage />
      </div>,
    ),
  },
  {
    path: '/item/:sku',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ItemPage />
      </div>
    ),
  },
  {
    path: '/newOrder',
    element: withSection(
      'checkout',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <NewOrderPage />
      </div>,
    ),
  },
  {
    path: '/newOrder/:tradeName',
    element: withSection(
      'checkout',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <NewOrderPage />
      </div>,
    ),
  },
  {
    path: '/newOrder/:platform/:tradeName',
    element: withSection(
      'checkout',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <NewOrderPage />
      </div>,
    ),
  },
  {
    path: '/orderComplited',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ComplitedPayCart />
      </div>
    ),
  },
  {
    path: '/orderComplited/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ComplitedPayCart />
      </div>
    ),
  },
  {
    path: '/orderComplited/:platform/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ComplitedPayCart />
      </div>
    ),
  },
  {
    path: '/category/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ShadowPage />
      </div>
    ),
  },
  {
    path: '/catalog/:platform/:tradeName',
    element: (
      <div className='App__page'>
        <CatalogPage />
      </div>
    ),
  },
  {
    path: '/category/:platform/:tradeName',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <ShadowPage />
      </div>
    ),
  },
  {
    path: '/group',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SalePage />
      </div>
    ),
  },
  {
    path: '/group/newOrder',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SaleNewOrderPage />
      </div>
    ),
  },
  {
    path: '/group/myOrders',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SaleMyOrders />
      </div>
    ),
  },
  {
    path: '/group/myOrders/:code',
    element: (
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <SaleMyOrders />
      </div>
    ),
  },
  {
    path: '/account/:tradeName',
    element: withSection('página personal', <StaticPage />),
  },
  {
    path: '/account/facturas/:tradeName',
    element: withSection('facturas', <StaticPage />),
  },
  {
    path: '/account/order/:id',
    element: withSection('pedido', <StaticOrderFP />),
  },
  // Was shadowed by /order/:orderId → OrderPage. Reachable path for logistic print view.
  {
    path: '/logistic/order/:id',
    element: withSection('pedido logístico', <OrderPageLogistic />),
  },
  {
    path: '/albaran/:id',
    element: withSection('albarán', <AlbaranPage />),
  },
  {
    path: '/factura/:tradeName/:id',
    element: withSection('factura', <FacturaPage />),
  },
  {
    path: '/client/static/order/:id',
    element: withSection('pedido', <StaticOrderFP />),
  },
  {
    path: '/owner/:tradeName',
    element: withSection(
      'owner',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <OwnerPage />
      </div>,
    ),
  },
  {
    path: '/agent/:tradeName',
    element: withSection(
      'agent',
      <div className='App__page'>
        <ToTopBtn />
        <Header />
        <HeaderMobile />
        <PreviewNavMobile />
        <OwnerPage />
      </div>,
    ),
  },
])
